import { makeUnorderedSelectors } from '@/store/repository';
import { Choice } from '@/store/types';

const selector = makeUnorderedSelectors<Choice>();

export const { get, getAll, getOrNull } = selector;
